/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { People1BossIcon16Light } from './People1BossIcon16Light';
import { People1BossIcon16Regular } from './People1BossIcon16Regular';
import { People1BossIcon16Solid } from './People1BossIcon16Solid';
import { People1BossIcon20Light } from './People1BossIcon20Light';
import { People1BossIcon20Regular } from './People1BossIcon20Regular';
import { People1BossIcon20Solid } from './People1BossIcon20Solid';
import { People1BossIcon24Regular } from './People1BossIcon24Regular';
import { People1BossIcon24Solid } from './People1BossIcon24Solid';
import { People1BossIcon32Regular } from './People1BossIcon32Regular';
import { People1BossIcon64Regular } from './People1BossIcon64Regular';
var sizes = {
    16: {
        light: People1BossIcon16Light,
        regular: People1BossIcon16Regular,
        solid: People1BossIcon16Solid,
    },
    20: {
        light: People1BossIcon20Light,
        regular: People1BossIcon20Regular,
        solid: People1BossIcon20Solid,
    },
    24: {
        regular: People1BossIcon24Regular,
        solid: People1BossIcon24Solid,
    },
    32: {
        regular: People1BossIcon32Regular,
    },
    64: {
        regular: People1BossIcon64Regular,
    },
};
export var People1BossIcon = forwardRef('People1BossIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
